import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { PaymentProcessorModel } from 'src/app/admin-panel/models/business/payment-processor.model';
import { SearchPaymentProcessorModel } from 'src/app/admin-panel/models/business/search-payment-processor.model';
import { UpdatePaymentProcessorModel } from 'src/app/admin-panel/models/business/update-payment-processor.model';
import { DropdownHelperModel } from 'src/app/admin-panel/models/helpers/dropdown-helper.model';
import { PaymentProcessorService } from 'src/app/admin-panel/services/business/payment-processor.service';
import { AddOrEditPaymentProcessorsComponent } from './add-or-edit-payment-processors/add-or-edit-payment-processors.component';
import { DeletePaymentProcessorsComponent } from './delete-payment-processors/delete-payment-processors.component';
import { DetailsPaymentProcessorsComponent } from './details-payment-processors/details-payment-processors.component';
import { SuspendPaymentProcessorsComponent } from './suspend-payment-processors/suspend-payment-processors.component';
import { MembershipPlanModel } from 'src/app/_models/Company/membership-plan-model';
import { SearchMembershipPlanModel } from 'src/app/admin-panel/models/business/search-membership-plan.model';
import { ProjectLogoMapEnum } from 'src/app/admin-panel/enums/project-logo-map.enum';
import { ProjectId } from 'src/app/admin-panel/enums/project-id.enum';

@Component({
  selector: 'app-payment-processors',
  templateUrl: './payment-processors.component.html',
  styleUrls: ['./payment-processors.component.scss']
})
export class PaymentProcessorsComponent implements OnInit {

  public paymentProcessorListMap: { [key: number]: PaymentProcessorModel[] } = {};
  public searchPaymentProcessorModelMap: { [key: number]: SearchPaymentProcessorModel } = {};
  public spinnerMap: { [key: number]: boolean } = {};
  public spinner: boolean = false;
  public projectList: Array<{name: string, value: number}> = new Array<{name: string, value: number}>();

  //#region Fields
  public imagePath: string = './assets/images/icons/venue-logo-placeholder.png'
  public src_drop_opt: Array<DropdownHelperModel>;
  public src_drop_opt_1: DropdownHelperModel;
  public src_drop_opt_2: DropdownHelperModel;
  public selected_drop_opt: DropdownHelperModel;
  public unsubscribe: Subject<void> = new Subject<void>();
  public totalPages: number;
  public totalRecords: number;
  //#endregion
  //#region Constructor
  constructor(
    public dialogService: DialogService,
    public paymentProcessorService: PaymentProcessorService,
    private messageService: MessageService,
    public translate: TranslateService
  ) {
    this.src_drop_opt = new Array<DropdownHelperModel>();
    this.src_drop_opt_1 = new DropdownHelperModel()
    this.src_drop_opt_1.id = '1';
    this.src_drop_opt_1.name = 'A_Z';
    this.src_drop_opt_2 = new DropdownHelperModel()
    this.src_drop_opt_2.id = '2';
    this.src_drop_opt_2.name = 'Z_A';
    this.src_drop_opt.push(this.src_drop_opt_1);
    this.src_drop_opt.push(this.src_drop_opt_2);
  }

  ngOnInit(): void {
    // this.getPaymentProcessors(this.searchPaymentProcessorModel);
    this.getAllProjects();
  }
  //#endregion
  //#region Public Methods

  getPaymentProcessors1(projectId: number, searchModel: SearchPaymentProcessorModel,showSpinner: boolean = true) {
    projectId = 1;
    // searchModel.projectId = projectId;
    this.spinnerMap[projectId] = showSpinner;
    this.paymentProcessorService.getpaymentprocessors(searchModel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.totalPages = response.totalPages;
          this.totalRecords = response.totalRecords;
          if (this.searchPaymentProcessorModelMap[projectId].pageNumber > 1) {
            this.paymentProcessorListMap[projectId] = this.paymentProcessorListMap[projectId].concat(response.data)
          }
          else {
            this.paymentProcessorListMap[projectId] = response.data;
          }
          this.spinnerMap[projectId] = false;
        },
        error: errorResponse => {
          this.spinnerMap[projectId] = false;
          if (errorResponse.error) {
           this.messageService.add({ severity: 'error', summary: "Server Error", life: 2000 });
         }
        }
      });
  }

  loadMorePaymentProcessors1(projectId: number){
    this.searchPaymentProcessorModelMap[projectId].pageNumber = this.searchPaymentProcessorModelMap[projectId].pageNumber + 1;
    this.getPaymentProcessors1(projectId, this.searchPaymentProcessorModelMap[projectId]);
  }

  getAllProjects() {
    this.spinner = true;
    this.paymentProcessorService.getAllProjects()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.projectList = response;
          this.projectList.forEach(product => {
            this.searchPaymentProcessorModelMap[product.value] = new SearchPaymentProcessorModel();
            this.paymentProcessorListMap[product.value] = new Array<PaymentProcessorModel>();
            // this.getPaymentProcessors1(product.value, this.searchPaymentProcessorModelMap[product.value], false);//za spinerot
            // this.getPaymentProcessors1(product.value, this.searchPaymentProcessorModelMap[product.value]); //ok
          });
          //temp
          this.getPaymentProcessors1(1, this.searchPaymentProcessorModelMap[1],true);
          this.spinner = false;
        },
        error: errorResponse => {
          this.spinner = false;
          if (errorResponse.error) {
            this.messageService.add({ severity: 'error', summary: "Server Error", life: 2000 });
          }
        }
      });
  };
  getLogoUrl(value: number) {
    if (value === ProjectId.SocialiteEvents) {
      return ProjectLogoMapEnum.SocialiteEvents;
    } else if (value === ProjectId.SocialitePOS) {
      return ProjectLogoMapEnum.SocialitePOS;
    } else {
      return ProjectLogoMapEnum.SocialiteResy;
    }
  }

  addNewPaymentProcessors() {
    const ref = this.dialogService.open(AddOrEditPaymentProcessorsComponent, {
      header: 'Add New Payment Processor',
      width: '760px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  ediPaymentProcessor(Id: string,projectId: number ) {
    const ref = this.dialogService.open(AddOrEditPaymentProcessorsComponent, {
      data: {
        id: Id,
      },
      header: this.translate.instant('BUSINESS.EDIT_PAYMENT_PROCESSOR'),
      width: '300px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchPaymentProcessorModelMap[projectId].pageNumber = 1;
        this.getPaymentProcessors1(projectId, this.searchPaymentProcessorModelMap[projectId]);
        let summary = this.translate.instant('BUSINESS.PAYMENT_PROCESSOR_EDITED');
        this.messageService.add({severity:'success', summary, life:3000});
      }
    });
  }
  detailsProcessorList(id: string) {
    const ref = this.dialogService.open(DetailsPaymentProcessorsComponent, {
      data: {
        id: id
      },
      header: 'Details Payment Processor',
      width: '760px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  suspendProcessorList(id: string) {
    const ref = this.dialogService.open(SuspendPaymentProcessorsComponent, {
      data: {
        id: id
      },
      header: 'Suspend Payment Processor',
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  deleteProcessorList(id: string) {
    const ref = this.dialogService.open(DeletePaymentProcessorsComponent, {
      data: {
        id: id
      },
      header: 'Delete Payment Processor',
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  // searchPaymentProcessor(searchModel: SearchPaymentProcessorModel) {
  //   this.paymentProcessorList = new Array<PaymentProcessorModel>();
  //   searchModel.pageNumber = 1;
  //   this.getPaymentProcessors(this.searchPaymentProcessorModel)
  // }
  // clearSearch() {
  //   this.paymentProcessorList = new Array<PaymentProcessorModel>();
  //   this.getPaymentProcessors(this.searchPaymentProcessorModel)
  // }
  //#endregion
  //#Private Methods
  //#endregion
}
